import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { BsDropdownModule, ModalModule } from 'ngx-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule, MdDatepickerModule, MdNativeDateModule } from '@angular/material';
import 'hammerjs';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { AgmCoreModule } from '@agm/core';

import { ContentService } from './shared/services/content.service';
import { EmailService } from './shared/services/email.service';
import { SlackService } from './shared/services/slack.service';
import { NotificationService } from './shared/services/notification.service';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { OfferModalComponent } from './shared/components/offer-modal/offer-modal.component';
import { PromotionModalComponent } from './shared/components/promotion-modal/promotion-modal.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { ServicesComponent } from './services/services.component';
import { GalleryComponent } from './gallery/gallery.component';
import { PricesComponent } from './prices/prices.component';
import { PromotionComponent } from './promotion/promotion.component';
import { ContactComponent } from './contact/contact.component';
import { LegalComponent } from './legal/legal.component';

export const firebaseConfig = {
	apiKey: "AIzaSyDYX_IrNmgb3jwy5GHN-AeEyT9gNjdYtAM",
	authDomain: "aqua-apartman.firebaseapp.com",
	databaseURL: "https://aqua-apartman.firebaseio.com",
	projectId: "aqua-apartman",
	storageBucket: "aqua-apartman.appspot.com",
	messagingSenderId: "673600357925"
};

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		OfferModalComponent,
		PromotionModalComponent,
		FrontpageComponent,
		ServicesComponent,
		GalleryComponent,
		PricesComponent,
		PromotionComponent,
		ContactComponent,
		LegalComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		RouterModule.forRoot([
			{ path: '', component: FrontpageComponent },
			{ path: 'services', component: ServicesComponent },
			{ path: 'gallery', component: GalleryComponent },
			{ path: 'prices', component: PricesComponent },
			{ path: 'promotion', component: PromotionComponent },
			{ path: 'contact', component: ContactComponent },
			{ path: 'legal', component: LegalComponent },
			{ path: '**', component: FrontpageComponent }
		]),
		BsDropdownModule.forRoot(),
		ModalModule.forRoot(),
		BrowserAnimationsModule,
		MaterialModule,
		MdDatepickerModule,
		MdNativeDateModule,
		ReCaptchaModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyDVFB7QqFYOLX6qrnKr3HoFwWSN_A0jkGo'
		})
	],
	providers: [
		ContentService,
		EmailService,
		SlackService,
		NotificationService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts